import React, { createContext, useContext } from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FONT_GSS_FUTURA_SEMI_BOLD } from '@monorepo/shared/src/themes/defaultTheme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import makeStyles from '@mui/styles/makeStyles';
import {
  remCalc,
  translate,
} from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';

const t = (key: string, options?) => translate('reports', key, options);

// react-to-print v3 dropped PrintContextConsumer; this replaces it so
// ReportDownloadButton usages that rely on an ancestor print handler keep working
export const PrintContext = createContext<{ handlePrint: () => void }>({
  handlePrint: () => null,
});

interface ReportDownloadButtonProps extends ButtonProps {
  text?: string;
}

const ReportDownloadButton: React.FC<ReportDownloadButtonProps> = ({
  variant = 'contained',
  color = 'primary',
  text = t('downloadReport'),
  onClick,
  ...rest
}) => {
  const classes = useStyles();
  const { handlePrint } = useContext(PrintContext);

  return (
    <Button
      onClick={onClick ?? handlePrint}
      variant={variant}
      color={color}
      disableElevation={true}
      {...rest}
    >
      <Typography className={classes.buttonText}>
        <FontAwesomeIcon icon={faDownload} className={classes.downloadIcon} />
        {text}
      </Typography>
    </Button>
  );
};

const useStyles = makeStyles(() => ({
  buttonText: {
    fontSize: remCalc(14),
    lineHeight: remCalc(24),
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
  },
  downloadIcon: {
    marginRight: remCalc(6),
    fontSize: remCalc(16),
  },
}));

export default ReportDownloadButton;
